import React, { useState } from "react";
import { Plus } from "lucide-react";

const ResourcesRequired = () => {
  const [enabled, setEnabled] = useState(false);

  return (
    <div className="space-y-6">
      {/* Header row */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-xl font-semibold flex items-center gap-2">
            Resources required
            <span
              className={`text-xs px-2 py-0.5 rounded-full ${
                enabled
                  ? "bg-green-100 text-green-700"
                  : "bg-gray-200 text-gray-600"
              }`}
            >
              {enabled ? "On" : "Off"}
            </span>
          </h2>
          <p className="text-gray-500 text-sm">
            Require specific resources when performing this service
          </p>
        </div>

        {/* Toggle switch */}
        <button
          onClick={() => setEnabled(!enabled)}
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
            enabled ? "bg-purple-600" : "bg-gray-300"
          }`}
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
              enabled ? "translate-x-6" : "translate-x-1"
            }`}
          />
        </button>
      </div>

      {/* Content if enabled */}
      {enabled && (
        <div className="flex flex-col items-center justify-center text-center py-16">
          {/* Placeholder icon */}
          <div className="w-16 h-16 flex items-center justify-center mb-4">
            <img
              src="https://cdn-icons-png.flaticon.com/512/3176/3176362.png"
              alt="resource placeholder"
              className="w-12 h-12 opacity-70"
            />
          </div>
          <p className="font-medium text-gray-700 mb-1">
            No resources in workspaces
          </p>
          <p className="text-gray-500 text-sm mb-6">
            Add a resource to your workspace to get started
          </p>
          <button className="flex items-center gap-2 px-4 py-2 rounded-md border border-gray-300 hover:bg-gray-100 text-sm font-medium">
            <Plus size={16} />
            Add resource
          </button>
        </div>
      )}
    </div>
  );
};

export default ResourcesRequired;
